<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-消息设置-获取手机号
  -->
  <div class="pt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="详情内容：" v-if="form.model.isPicture == 0">
        <div class="edit_container">
          <Uediter :text="form.model.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";
import Uediter from "@/components/UE.vue";

export default {
  components: {
    /*编辑器*/
    Uediter
  },
  data() {
    return {
      form: {},
      /*富文本框配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      is_upload: false,
      config: {
        total: 9,
        fileType: "image"
      }
    };
  },
  created() {
    this.getParams();
    //this.ueditor.text = this.form.model.content;
  },
  methods: {
    /*获取配置数据*/
    getParams() {
      let self = this;
      SettingApi.getPhoneDetail({}, true)
        .then(res => {
          let vars = res.data.vars.values;
          self.form.checkedCities = vars.area_type;
          // 转成整数，兼容组件
          for (let i = 0; i < self.form.checkedCities.length; i++) {
            self.$set(
              self.form.checkedCities,
              i,
              parseInt(self.form.checkedCities[i])
            );
          }
          self.form.send_day = vars.send_day;
          self.all_type = res.data.all_type;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = this.form;
      console.log(params);
      self.loading = true;
      SettingApi.editGetPhone(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*获取富文本框内容*/
    getContent: function() {
      //return this.$refs.ue.getUEContent();
    },

    /*获取富文本内容*/
    contentChangeFunc(e) {
      this.form.model.content = e;
    },
    openUpload() {
      this.is_upload = true;
    },
    /*上传商品图片*/
    returnImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.model.contentImage.concat(e);
        this.$set(this.form.model, "contentImage", imgs);
      }
      this.is_upload = false;
    },
    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.contentImage.splice(index, 1);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/setting/protocol/part/agree.vue